// ©2024 Austin App House. All rights reserved.
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import DatePicker from 'react-datepicker';

const CetCertificatesForContractor = ({
  certificates,
  handlerCheck,
  checkedList = new Set(),
  contractorCertificates,
  handlerDate,
  handlerExpiresDate,
}) => (
  <div className="certificates-form fields_group">
    <div className="certificates-form__header field_row">
      <div className="field_name">Certification</div>
      <div className="field_name">Date Passed</div>
      <div className="field_name">Date Expires</div>
    </div>

    {certificates.map((certificate) => (
      <div className="certificates-form__item field_col" key={certificate._id}>
        <div className="field_row certificates-form__row">
          <div className="field_block certificates-form__cert">
            <label className="check_btn">
              <input
                type="checkbox"
                id={certificate._id}
                name={certificate.name}
                value={certificate._id}
                onChange={handlerCheck}
                checked={checkedList.has(certificate._id)}
              />
              {certificate.name}
            </label>
          </div>

          {certificate.passed_date_required ? (
            <div className="field_block certificates-form__date">
              <span className="certificates-form__mobile-label field_name">Date Passed</span>
              <DatePicker
                className="dashboard-input subpage-certificates-date"
                dateFormat="MM/dd/yy"
                placeholderText="MM/dd/yy"
                name="date"
                selected={contractorCertificates[certificate._id]?.passed_at}
                onChange={(date) => handlerDate(certificate._id, date)}
              />
            </div>
          ) : null}

          {certificate.expires_date_required ? (
            <div className="field_block certificates-form__expires">
              <span className="certificates-form__mobile-label field_name">Date Expires</span>
              <DatePicker
                className="dashboard-input subpage-certificates-date"
                dateFormat="MM/dd/yy"
                placeholderText="MM/dd/yy"
                name="expiresdate"
                selected={contractorCertificates[certificate._id]?.expires_at}
                onChange={(expiresdate) => handlerExpiresDate(certificate._id, expiresdate)}
              />
            </div>
          ) : null}
        </div>
      </div>
    ))}
  </div>
);

export default CetCertificatesForContractor;
